export default __webpack_public_path__ + "static/media/PAR.14fb4dda.png";